/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantAnnualIncomeDto } from '../models/PagedResultDto_ParticipantAnnualIncomeDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_CreateUpdateParticipantAnnualIncomeDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_CreateUpdateParticipantAnnualIncomeDto';
import type { Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto } from '../models/Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantAnnualIncomeService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAnnualIncomeParticipantAnnualIncomesList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-annual-income/participant-annual-incomes-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantAnnualIncome(
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_CreateUpdateParticipantAnnualIncomeDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-annual-income',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_ParticipantAnnualIncomeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAnnualIncome(
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_ParticipantAnnualIncomeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-annual-income',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppParticipantAnnualIncome(
id: string,
requestBody?: Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_CreateUpdateParticipantAnnualIncomeDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/participant-annual-income/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppParticipantAnnualIncome(
id: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/participant-annual-income/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppParticipantAnnualIncome1(
id: string,
): CancelablePromise<Wealthlane_CustomerService_Dtos_ParticipantAnnualIncome_ParticipantAnnualIncomeDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/participant-annual-income/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
